<template>
    <div>
        <img src="/images/loading.gif" />
    </div>
</template>

<style scoped>
div {
    text-align: center;
    margin: 16px;
    height: 32px;
}

img {
    height: 100%;
}
</style>
